import _ from "lodash"
import React from "react"
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {BsDiamondFill} from "react-icons/bs";
import {Link} from "react-router-dom";
import {Avatar} from "antd";
import {RiSignalTowerFill} from "react-icons/ri";
import getAvatar from "../../../helpers/getAvatar";
import classNames from "classnames";
import getTitle from "../../../helpers/getTitle";
import {getType} from "../../../apis/model/base";
import {renderIf, renderIfElse} from "../../Shared";
import {OrgType} from "../../AppLocals/Organization/components/OrgType";

const renderChannelModalItem = ( item, { t, index, onItemClick = item => null }) => {

    const {owner, total_followers, total_articles, description, categories = []} = item ?? {}

    const ItemTotal = ({ value, label }) => {
        return renderIfElse(
            value > 0,
            <div className="space-x-1 text-xs">
                <span className="font-bold text-color-000">
                    {value}
                </span>
                <span className="text-color-400 italic">
                    {t(label)}
                </span>
            </div>,
            <span />
        )
    }

    return (
        <div
            key={index} onClick={() => {onItemClick(item)}}
            className="p-2 border-t border-color-50 shadow-md hover:scale-2xs rounded-xl cursor-pointer">
            <div className="flex flex-col gap-2">
                <div className="flex items-center gap-3">
                    <Avatar
                        size={36}
                        src={getAvatar(owner)}
                        icon={<RiSignalTowerFill size={20} className="text-primary-300" />}
                        className={classNames("flex flex-center bg-primary-50 no-border", getType(owner) === 'organization' && 'rounded-md')}
                    />
                    <div className="flex flex-col">
                        <a className="font-bold text-color-000 no-underline">
                            {getTitle(item)}
                        </a>
                        <div className="space-x-1 text-xs italic leading-tight">
                            <span className="text-color-500 whitespace-no-wrap italic">
                                {t('created by')}
                            </span>
                            <Link to={getLinkToDetail(owner)} className="font-semibold text-green-500 no-underline">
                                {getTitle(owner)}
                            </Link>
                            {renderIf(
                                getType(owner) === 'organization',
                                <span className="text-blue-500">
                                    {'( '}<OrgType item={owner} className="font-medium text-xs italic"/>{' )'}
                                </span>
                            )}

                        </div>
                    </div>
                </div>
                <div className="ml-3 space-y-1">
                    {renderIf(
                        description,
                        <div className="text-xs text-color-400 max-lines-3">
                            {description}
                        </div>
                    )}
                    <div className="flex gap-4">
                        <ItemTotal value={total_followers} label="members" />
                        <ItemTotal value={total_articles} label="articles" />
                    </div>
                    {categories.length > 0 && (
                        <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1">
                            {_.get(item, 'categories', []).map(
                                (e, i) => (
                                    <Link
                                        key={i}
                                        target="_blank"
                                        to={getLinkToDetail(e)}
                                        className="text-primary text-xs font-semibold italic">
                                        <BsDiamondFill size={5} className="mr-1" style={{marginBottom: '0.1rem'}}/>
                                        {e.name}
                                    </Link>
                                )
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default renderChannelModalItem